module.exports = __webpack_public_path__ + "assets/img/head2-zh.720757c0.png";